var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rf-toolbar",class:{ sticky: _vm.sticky }},[_c('div',[_c('div',[_vm._t("left")],2),_vm._v(" "),_c('div',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }